import React from 'react';
import Section from '../components/ui/Section';
import PricingTier from '../components/pricing/PricingTier';
import { pricingTiers } from '../data/pricing';
import { Check } from 'lucide-react';
import CallToAction from '../components/home/CallToAction';

const PlansPage: React.FC = () => {
  const comparisonItems = [
    { name: 'AI Maturity Assessment', tiers: [true, true, true] },
    { name: 'Opportunity & Gap Map', tiers: [true, true, true] },
    { name: 'Competitive Scan', tiers: [true, true, true] },
    { name: 'Quick Wins & ROI List', tiers: [true, true, true] },
    { name: 'Full Strategic Roadmap', tiers: [false, true, true] },
    { name: 'Governance & Ethics Checklist', tiers: [false, true, true] },
    { name: 'Strategy Report (PDF + Deck)', tiers: [false, true, true] },
    { name: 'Custom Training Workshops', tiers: [false, false, true] },
    { name: 'Ongoing Q&A Support (30 days)', tiers: [false, false, true] },
  ];

  return (
    <>
      <Section className="pt-32 md:pt-40">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Simple, Transparent <span className="text-primary">Plans</span>
          </h1>
          <p className="text-xl md:text-2xl text-neutral-300 mb-8">
            Choose the plan that best fits your organization's AI journey
          </p>
          <p className="text-lg text-neutral-300">
            We guide companies through the process of building a real, actionable AI strategy. Our deliverables are designed to be executive-ready and execution-ready, usable across investor decks, internal comms, and operational planning.
          </p>
          <p className="text-lg text-neutral-300 mt-4">
            We offer three tiers based on your organization's needs and readiness.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          {pricingTiers.map((tier) => (
            <PricingTier 
              key={tier.id} 
              tier={tier} 
              isRecommended={tier.id === 2}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center">Side by Side Comparison</h2>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-neutral-700">
                  <th className="py-4 px-6 text-left font-medium text-lg">Deliverable</th>
                  <th className="py-4 px-6 text-center font-medium text-lg">Tier 1</th>
                  <th className="py-4 px-6 text-center font-medium text-lg">Tier 2</th>
                  <th className="py-4 px-6 text-center font-medium text-lg">Tier 3</th>
                </tr>
              </thead>
              <tbody>
                {comparisonItems.map((item, index) => (
                  <tr 
                    key={index} 
                    className={`border-b border-neutral-800 ${
                      index % 2 === 0 ? 'bg-neutral-900/30' : ''
                    }`}
                  >
                    <td className="py-4 px-6 text-neutral-300">{item.name}</td>
                    {item.tiers.map((included, tierIndex) => (
                      <td key={tierIndex} className="py-4 px-6 text-center">
                        {included && (
                          <Check size={24} className="text-primary mx-auto" />
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Section>
      <CallToAction />
    </>
  );
};

export default PlansPage;